import React from 'react';

const RouteComponent = React.lazy(() => import('.'));

export default {
  RouteComponent,
  path: '/saml/callback',
  name: 'samlCallback',
};
